module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-3-3.v1.jpg";